import Vue from "vue";
import vueKanban from "vue-kanban";

import "vue-kanban/src/assets/kanban.css";

Vue.use(vueKanban);
